import { ErrorResponse } from '../types/forms';

export const handleApiError = (error: any): ErrorResponse => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    return {
      message: error.response.data.message || 'An error occurred',
      errors: error.response.data.errors
    };
  } else if (error.request) {
    // The request was made but no response was received
    return {
      message: 'No response received from server'
    };
  } else {
    // Something happened in setting up the request that triggered an Error
    return {
      message: error.message || 'An unexpected error occurred'
    };
  }
};

export const isValidationError = (error: any): boolean => {
  return error.response?.status === 422 && error.response?.data?.errors;
};

export const formatValidationErrors = (errors: { [key: string]: string }): string => {
  return Object.entries(errors)
    .map(([field, message]) => `${field}: ${message}`)
    .join('\n');
};
